import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  installAnalytics,
  trackPageview,
  setAnalyticsUser,
  clearAnalyticsUser,
} from '../utils/analytics';
import { useAuth } from '../context/AuthContext';
import { useAgentAuth } from '../context/AgentAuthContext';

/**
 * Mounts once inside <BrowserRouter /> and:
 *   • Installs flush-on-unload listeners (once)
 *   • Fires trackPageview() on every route change
 *   • Syncs user identity from Auth + AgentAuth contexts → tracker
 *
 * No UI output.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const { agent } = useAgentAuth();

  useEffect(() => {
    installAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);

  // Push current identity into the tracker so session rows get populated
  useEffect(() => {
    if (agent?.id) {
      setAnalyticsUser({ userId: agent.id, userType: 'agent' });
    } else if (user?.id) {
      setAnalyticsUser({ userId: user.id, userType: 'b2c' });
    } else {
      clearAnalyticsUser();
    }
  }, [user?.id, agent?.id]);

  return null;
}
